module.exports = __webpack_public_path__ + "img/B98A6D_7B4F38_D1A68F_8C5B43-256px.cbf41443.png";